// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import api from './api/api'
// import { Lazyload, InfiniteScroll, Popup } from 'mint-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'
import VueQriously from 'vue-qriously'
import { Spinner } from 'mint-ui';
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  loading: "http://static.yunxi.tv/yps/defaultcover-img.png"
})
Vue.component(Spinner.name, Spinner);
Vue.use(VueQriously)
Vue.use(VueAwesomeSwiper, /* { default global options } */)

// Vue.use(Lazyload)
// Vue.use(InfiniteScroll)
// Vue.use(Popup)
// 公共文件入口引入 babel-polyfill , js 新特性可在 低版本浏览器中使用
require('babel-polyfill')

Vue.$api = Vue.prototype.$api = api;

Vue.$http = Vue.prototype.$http = axios


Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
    window.location.reload();
  }
  next()
});




// WEBPACK FOOTER //
// ./src/main.js